import { getAuth, onAuthStateChanged, signInWithEmailAndPassword } from 'firebase/auth';
import { addListnerForAuthStateVisibility, initFirebase } from "./utils/fbase";
import { toast } from "bulma-toast"
import { handleTelInputs, redirectAfterSignin } from './utils/helper-functions';
import { getFunctions, httpsCallable } from 'firebase/functions';

initFirebase()

onAuthStateChanged(getAuth(), (user) => {
    if (user) redirectAfterSignin()
})

document.addEventListener('DOMContentLoaded', () => {
    console.log("DOMContentLoaded")
    console.log(process.env.FBASE_APP_ID)

    addListnerForAuthStateVisibility()
    handleTelInputs()

    const form_create_account = document.getElementById('form_create_account')

    form_create_account.addEventListener('submit', async (ev) => {
        ev.preventDefault()
        const form = ev.target

        form.submit.classList.add('is-loading')
        const createUserAccount = httpsCallable(getFunctions(), 'createUserAccount')

        createUserAccount({
            email: form['email'].value || '',
            password: form['password'].value || '',
            name: form['name'].value || '',
            compnay_name: form['compnay_name'].value || '',
            address_line1: form['location-input'].value || '',
            address_line2: form['street_number-input'].value || '',
            address_city: form['locality-input'].value || '',
            address_state: form['administrative_area_level_1-input'].value || '',
            address_country: form['country-input'].value || '',
            address_postal_code: form['postal_code-input'].value || '',
            telephone_no: form['telephone_no'].value || ''
        })
            .then(() => signInWithEmailAndPassword(getAuth(), form['email'].value, form['password'].value))
            .then(() => {
                redirectAfterSignin()
            })
            .catch(error => {
                toast({
                    type: 'is-danger',
                    dismissible: true,
                    position: 'top-center',
                    message: 'Some error occurred! Please, try again after some time or contact us.'
                })
                form.submit.classList.remove('is-loading')
                console.error("Firebase: Could not create account.", error)
            })

    })


    try {
        const btn_signout_el = document.getElementById('btn_signout')
        btn_signout_el.addEventListener('click', () => {
            btn_signout_el.classList.add('is-loading')
            handleSignOut()
            btn_signout_el.classList.remove('is-loading')
        })
    } catch (error) {
        console.error("App: Could not add click event listner to #btn_signout.", error)
    }

})